import React, { createContext, useEffect, useState } from "react";

export const VisitedContext = createContext();

const initialState = {
    points: {},
    variables: {},
    ask_geolocation: true,
    info_page: false,
    summary_page: false,
    show_summary_page: false,

};

export function VisitedProvider(props) {

    const [visited, setVisited] = useState(() => JSON.parse(sessionStorage.getItem("visited")) || initialState);

    useEffect(() => {
        sessionStorage.setItem("visited", JSON.stringify(visited));
    }, [visited]);


    return <VisitedContext.Provider value={{
        points: visited.points,
        variables: visited.variables,
        ask_geolocation: visited.ask_geolocation,
        info_page: visited.info_page,
        summary_page: visited.summary_page,
        show_summary_page: visited.show_summary_page,

        setVisitedPoints: (points) => setVisited({ ...visited, points}),
        setVariables: (variables) => setVisited({ ...visited, variables}),
        setAskGeoLocation: (ask_geolocation) =>  setVisited({ ...visited, ask_geolocation}),
        setVisitedInfoPage: (info_page) => setVisited({ ...visited, info_page}),
        setVisitedSummaryPage: (summary_page) => setVisited({ ...visited, summary_page}),
        setShowSummaryPage: (show_summary_page) => setVisited({ ...visited, show_summary_page})

    }}
    >
        {props.children}
    </VisitedContext.Provider>;
}
